// src/pages/ComingSoon.jsx
import React from "react";
import { motion } from "framer-motion";
import { useLocation, Link } from "react-router-dom";

export default function ComingSoon() {
  const location = useLocation();

  // Build a nicer page title from the path: "/security-practices" -> "Security Practices"
  const pageName = location.pathname
    .replace(/^\//, "")
    .replace(/-/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());

  return (
    <motion.div
      className="min-h-screen flex items-center justify-center bg-blue-50 dark:bg-slate-900 px-4 sm:px-6 py-10"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.45 }}
    >
      <div className="w-full max-w-2xl">
        {/* Card */}
        <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-md border-t-4 border-blue-600 p-5 sm:p-8 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-800 dark:text-slate-100 mb-3 sm:mb-4">
            {pageName || "Coming Soon"}
          </h1>

          <p className="text-sm sm:text-base md:text-lg text-blue-600 dark:text-slate-300 mb-4 sm:mb-6">
            This page is under construction. We’re working hard to bring you something amazing.
          </p>

          <p className="text-xs sm:text-sm text-blue-700 dark:text-slate-200">
            If you have any questions, feel free to contact us at{" "}
            <a
              href="mailto:admin@coinzetto.com"
              className="font-medium text-blue-700 dark:text-blue-300 underline underline-offset-2 hover:opacity-90"
            >
              admin@coinzetto.com
            </a>{" "}
            or visit our{" "}
            <Link
              to="/support"
              className="font-medium text-blue-700 dark:text-blue-300 underline underline-offset-2 hover:opacity-90"
            >
              Support Page
            </Link>
            .
          </p>

          {/* Optional quick actions (mobile-friendly) */}
          <div className="mt-5 sm:mt-6 flex flex-col xs:flex-row items-center justify-center gap-2 sm:gap-3">
            <Link
              to="/"
              className="w-full xs:w-auto inline-flex items-center justify-center px-4 py-2.5 rounded-lg bg-blue-600 text-white text-sm sm:text-base font-semibold hover:bg-blue-700 active:scale-[0.99] transition"
            >
              Back to Home
            </Link>
            <Link
              to="/dashboard"
              className="w-full xs:w-auto inline-flex items-center justify-center px-4 py-2.5 rounded-lg border border-blue-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-blue-800 dark:text-slate-100 text-sm sm:text-base font-semibold hover:bg-blue-50 dark:hover:bg-slate-900/70 active:scale-[0.99] transition"
            >
              Go to Dashboard
            </Link>
          </div>
        </div>

        {/* Small note */}
        <p className="mt-4 text-center text-[11px] sm:text-xs text-blue-600 dark:text-slate-400">
          Tip: switch themes in Settings → Appearance for the best experience.
        </p>
      </div>
    </motion.div>
  );
}
